// src/geograph/pages/about.js (例: 元の場所に合わせて調整)
import React from "react";
import { LinkFunc } from "../../buttons/linkFunc";
import { TojiruX } from "../../buttons/tojiruX";
import { GeographFooter } from "../../panels/geographFooter";
import { GeographHeader } from "../../panels/geographHeader";

import { ABOUT_RELEASES } from "./releases"; // ←追加（パスは配置に合わせて）

const AboutTitle = ({ children, latest, date, title }) => {
  return (
    <li className="mb-10 ml-6">
      <span className="absolute flex items-center justify-center w-6 h-6 bg-blue-900 rounded-full -left-3 ring-8 ring-gray-900">
        <svg
          className="w-3 h-3 text-blue-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
            clipRule="evenodd"
          ></path>
        </svg>
      </span>

      <h3 className="flex items-center mb-1 text-lg font-semibold text-white">
        {title}{" "}
        {latest && (
          <span className="bg-blue-200 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded ml-3">
            Latest
          </span>
        )}
      </h3>

      <time className="block mb-2 text-sm font-normal leading-none text-gray-500">
        Released on {date}
      </time>

      {children}
    </li>
  );
};

const AboutP = ({ children }) => {
  return (
    <p className="mb-4 text-base font-normal text-gray-200 dark:text-gray-200">
      {children}
    </p>
  );
};

/** 既存の“リンクボタン”UIを共通化（必要な場合のみ） */
const AboutLinkButton = ({ href, label }) => {
  return (
    <a
      href={href}
      className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
    >
      <svg
        className="w-4 h-4 mr-2"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
          clipRule="evenodd"
        ></path>
      </svg>
      {label}
    </a>
  );
};

export const About = () => {
  const goBack = () => window.history.back();

  return (
    <>
      <GeographHeader />

      <div
        onClick={goBack}
        className="absolute z-20 h-full w-full pointer-events-auto bg-black/50"
      />

      <div className="absolute z-30 mt-12 md:mt-14 max-h-full font-mono text-white md:mx-[10vw] w-full md:w-[80vw]">
        <div className="absolute z-20 bg-gradient-to-r from-black/90 via-black/80 to-black/90 px-10 scroll-auto h-[calc(100vh-70px)] md:h-[calc(100vh-92px)] overflow-auto">
          <TojiruX />

          <ol className="relative mt-5 border-l border-gray-200 dark:border-gray-700 scroll-auto text-left">
            {ABOUT_RELEASES.map((r, idx) => (
              <AboutTitle
                key={r.id || `${r.title}_${r.dateLabel}_${idx}`}
                latest={idx === 0}
                date={r.dateLabel}
                title={r.title}
              >
                {/* bullets */}
                {Array.isArray(r.bullets) &&
                  r.bullets.map((b, i) => <AboutP key={`${r.id}_b_${i}`}>{b}</AboutP>)}

                {/* links */}
                {Array.isArray(r.links) &&
                  r.links.map((lnk, i) => (
                    <div key={`${r.id}_l_${i}`} className="mb-4">
                      <AboutLinkButton href={lnk.href} label={lnk.label} />
                    </div>
                  ))}
              </AboutTitle>
            ))}
          </ol>

          <div className="text-center w-full my-10">
            <LinkFunc onClick={goBack} />
          </div>
        </div>
      </div>

      <GeographFooter />
    </>
  );
};
